function Melilla({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1625)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#338AF3"/>
  <path d="M7.65222 17.3916H24.3478V19.4785H7.65222V17.3916Z" fill="#818085"/>
  <path d="M10.4348 11.1307L16 11.8264L21.5652 11.1307V7.79155L19.3391 8.90462L16 5.56543L12.6609 8.90462L10.4348 7.79155V11.1307Z" fill="#FFDA44"/>
  <path d="M9.04354 21.5656H6.95654V17.7395L7.65223 16.696L6.95654 15.6525V13.2178H9.04354V21.5656Z" fill="#F0F0F0"/>
  <path d="M25.0435 21.5656H22.9565V13.2178H25.0435V15.6525L24.3479 16.7135L25.0435 17.7396V21.5656Z" fill="#F0F0F0"/>
  <path d="M6.95654 15.6523H25.0435V17.7393H6.95654V15.6523Z" fill="#ACABB1"/>
  <path d="M16 24.3482C12.9313 24.3482 10.4348 21.8516 10.4348 18.783V11.1309H21.5653V18.783C21.5652 21.8516 19.0687 24.3482 16 24.3482Z" fill="#F0F0F0"/>
  <path d="M16 22.2611C14.082 22.2611 12.5217 20.7008 12.5217 18.7829V13.2178H19.4782V18.7829C19.4782 20.7008 17.9179 22.2611 16 22.2611Z" fill="#0052B4"/>
  <path d="M10.4348 11.1309H12.5218V13.2178H10.4348V11.1309Z" fill="#D80027"/>
  <path d="M19.4783 11.1309H21.5652V13.2178H19.4783V11.1309Z" fill="#D80027"/>
  <path d="M19.4783 15.6523H21.5652V17.7393H19.4783V15.6523Z" fill="#D80027"/>
  <path d="M10.4348 15.6523H12.5218V17.7393H10.4348V15.6523Z" fill="#D80027"/>
  <path d="M14.9565 11.1309H17.0435V13.2178H14.9565V11.1309Z" fill="#D80027"/>
  <path d="M16 22.2617C15.6365 22.2617 15.2861 22.2054 14.9565 22.1016V24.2491C15.2948 24.3136 15.6433 24.3487 16 24.3487C16.3568 24.3487 16.7053 24.3136 17.0435 24.2491V22.1016C16.714 22.2054 16.3635 22.2617 16 22.2617Z" fill="#D80027"/>
  <path d="M12.5682 19.3477L10.9027 21.0132C11.1915 21.6706 11.6035 22.2618 12.1098 22.7574L13.5848 21.2824C13.0585 20.7738 12.6918 20.1013 12.5682 19.3477Z" fill="#D80027"/>
  <path d="M21.0972 21.0132L19.4317 19.3477C19.3081 20.1013 18.9415 20.7737 18.4152 21.2825L19.8902 22.7575C20.3964 22.2618 20.8085 21.6706 21.0972 21.0132Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Melilla;
